import React, { PureComponent } from 'react';
import SuggestionsListItem from 'modules/homescreen/components/SuggestionsListItem';

const CSS = require('./SuggestionsList.less');

interface SuggestionsListProps {
  title?: string;
  suggestions?: any;
  onSuggestionChange: (suggestion: { city: string; country: string; place: string }, lockIn?: boolean) => void;
  selectedSuggestion?: { city: string; country: string; place: string };
  suggestionType: 'suggestions' | 'popularlocations' | 'recentsearches' | 'other' | 'nearbydestinations';
}

class SuggestionsList extends PureComponent<SuggestionsListProps> {

  focusNextSuggestion = (listIndex: number): { city: string; country: string } => {
    const suggestions = this.props.suggestions;
    const newSuggestion = suggestions[(listIndex + 1) % suggestions.length];
    this.props.onSuggestionChange(newSuggestion);
    return newSuggestion;
  };

  focusPreviousSuggestion = (listIndex: number): { city: string; country: string } => {
    const suggestions = this.props.suggestions;
    const newSuggestion = suggestions[(suggestions.length + listIndex - 1) % suggestions.length];
    this.props.onSuggestionChange(newSuggestion);
    return newSuggestion;
  };

  shouldFocusItem = (country, city, place) => {
    return this.props.selectedSuggestion &&
      (
        this.props.selectedSuggestion.city === city &&
        this.props.selectedSuggestion.country === country &&
        this.props.selectedSuggestion.place === place
      );
  }

  getItemKey = (country, city, place) => {
    return place ? place : `${city}-${country || city}`;
  }

  render() {
    const { title, onSuggestionChange, suggestions } = this.props;
    if (!suggestions || suggestions.length === 0) {
      return null;
    }

    return (
      <div className={CSS.SuggestionsList} data-test-id="CitySuggestionsList">
        {
          title &&
          <h3 className={CSS.Title}>{title}</h3>
        }
        <ul>
          {suggestions.map((suggestion, index) => {
            const { city, country, place, distanceTo, isNew } = suggestion;
            const { isComingSoon = false } = suggestion;
            return (
              <SuggestionsListItem
                suggestionType={this.props.suggestionType}
                inFocus={this.shouldFocusItem(country, city, place)}
                key={this.getItemKey(country, city, place)}
                country={country}
                city={city}
                place={place}
                onSelect={onSuggestionChange}
                distanceTo={distanceTo}
                isComingSoon={isComingSoon}
                focusNextSuggestion={this.focusNextSuggestion}
                focusPreviousSuggestion={this.focusPreviousSuggestion}
                listIndex={index}
                isNew={isNew}
              />
            );
          })}
        </ul>
      </div>
    );
  }
}

export default SuggestionsList;
